import {Component, EventEmitter, OnDestroy, Output} from "@angular/core";
import {NbSortingService} from "./nb-sorting.service";


@Component({
  selector: '[nb-sorting]',
  providers: [NbSortingService],
  template: `
    <ng-content></ng-content>
  `
})
export class NbSortingComponent implements OnDestroy{
  @Output() public onSorted:EventEmitter<SortInfo> = new EventEmitter();

  private subscription;
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  constructor(private sortingService: NbSortingService) {
    this.subscription = this.sortingService.subscribe(ch => this.onSorted.emit(ch));
  }
}

export class SortInfo {
  code: string;
  sorting: string;
}

